import { create } from "zustand";
import { persist } from "zustand/middleware";


const VALID_STATUSES = ["CLOSED", "SUCCESS", "FAILED"];

const useCheckoutStatus = create(
    persist((set, get) => ({
        paymentStatus: null,

        // only use in EcomCheckoutStatus component so not exported in useStore
        setPaymentStatus: (status) => {
            if (VALID_STATUSES.includes(status)) {
                set({ paymentStatus: status });
            }
        },

        // only use in EcomCheckoutStatus component so not exported in useStore
        resetPaymentStatus: () => {
            if (get()?.paymentStatus)
                set({ paymentStatus: null });

        },
    }),
        {
            name: "ecom-checkout-status", // key for local storage
            getStorage: () => localStorage,
        }
    )
);

export default useCheckoutStatus;
